(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();
        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var isThemeEditor = !!(window.Shopify && window.Shopify.designMode);

var applyV1RelatedCardHeightScale = function(section) {
  if (isThemeEditor) return;
  if (!section) return;
  if (!document.body.classList.contains('template-suffix-v1')) return;
  if (!window.matchMedia('(max-width: 767px)').matches) return;
  if (section.dataset.v1MobileSwipeEnable !== 'true') return;

  var scale = Number(section.dataset.v1MobileCardHeightScale || 100) / 100;
  var imageContainers = section.querySelectorAll('.related-products__track .product-block .image-cont');

  imageContainers.forEach(function(imageContainer) {
    imageContainer.style.removeProperty('height');
    if (Math.abs(scale - 1) < 0.001) return;

    var naturalHeight = imageContainer.getBoundingClientRect().height;
    if (!naturalHeight) return;

    imageContainer.style.height = (naturalHeight * scale) + 'px';
    imageContainer.style.overflow = 'hidden';
  });
};

var centerUnderfilledRelatedTrack = function(section) {
  if (!section) return;
  var track = section.querySelector('.related-products__track');
  if (!track) return;

  track.style.removeProperty('padding-inline-start');
  track.style.removeProperty('padding-inline-end');

  if (!track.classList.contains('related-products__track--underfilled')) return;
  if (window.matchMedia('(max-width: 767px)').matches && section.dataset.v1MobileSwipeEnable === 'true') return;

  var renderedCount = Number(track.dataset.relatedRenderCount || 0);
  var maxCount = Number(track.dataset.relatedMaxCount || 0);
  if (!renderedCount || !maxCount || renderedCount >= maxCount) return;

  var items = Array.prototype.slice.call(track.children).filter(function(node) {
    return node && node.nodeType === 1;
  });
  if (!items.length) return;

  var firstRect = items[0].getBoundingClientRect();
  if (!firstRect.width) return;
  var gap = Number.parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap || '0') || 0;
  var contentWidth = (firstRect.width * renderedCount) + (Math.max(0, renderedCount - 1) * gap);
  var availableWidth = track.clientWidth;
  var sidePadding = Math.floor((availableWidth - contentWidth) / 2);
  if (sidePadding > 0) {
    track.style.paddingInlineStart = sidePadding + 'px';
    track.style.paddingInlineEnd = sidePadding + 'px';
  }
};

var initV1RelatedSwipe = function(section) {
  try {
  if (isThemeEditor) return;
  if (!section) return;
  if (!document.body.classList.contains('template-suffix-v1')) return;
  if (!window.matchMedia('(max-width: 767px)').matches) return;
  if (section.dataset.v1MobileSwipeEnable !== 'true') return;

  var track = section.querySelector('.related-products__track');
  if (!track) return;

  var infinite = section.dataset.v1MobileSwipeInfinite === 'true';
  var cloneCountSetting = Number(section.dataset.v1MobileSwipeClones || 1);
  if (!infinite) return;

  if (section.dataset.v1SwipeLoopBound === 'true') return;
  section.dataset.v1SwipeLoopBound = 'true';

  var getItems = function() {
    return Array.prototype.slice.call(track.children).filter(function(node) {
      return node && node.nodeType === 1 && (!node.dataset || node.dataset.v1RelatedClone !== 'true');
    });
  };

  var getGap = function() {
    var style = window.getComputedStyle(track);
    return Number.parseFloat(style.columnGap || style.gap || '0') || 0;
  };

  var getStep = function() {
    var first = Array.prototype.slice.call(track.children).find(function(node) {
      return node && node.nodeType === 1;
    });
    if (!first) return 0;
    return first.getBoundingClientRect().width + getGap();
  };

  var originals = getItems();
  if (originals.length < 2) return;

  var cloneCount = Math.min(Math.max(1, cloneCountSetting), originals.length);
  var prepend = originals.slice(-cloneCount).map(function(node) {
    var clone = node.cloneNode(true);
    clone.setAttribute('data-v1-related-clone', 'true');
    return clone;
  });
  var append = originals.slice(0, cloneCount).map(function(node) {
    var clone = node.cloneNode(true);
    clone.setAttribute('data-v1-related-clone', 'true');
    return clone;
  });

  prepend.reverse().forEach(function(clone) { track.prepend(clone); });
  append.forEach(function(clone) { track.append(clone); });

  requestAnimationFrame(function() {
    var step = getStep();
    if (step > 0) track.scrollLeft = step * cloneCount;
  });

  var ticking = false;
  track.addEventListener('scroll', function() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function() {
      ticking = false;
      var step = getStep();
      if (!step) return;
      var count = originals.length;
      var min = step * (cloneCount - 0.5);
      var max = step * (cloneCount + count - 0.5);
      if (track.scrollLeft < min) {
        track.scrollLeft += step * count;
      } else if (track.scrollLeft > max) {
        track.scrollLeft -= step * count;
      }
    });
  }, { passive: true });
  } catch (error) {
    console.warn('V1 related swipe init skipped due runtime error', error);
  }
};

var loadProductRecommendationsIntoSection = function(productRecommendationsSection) {
  if (isThemeEditor) return;
  if (!productRecommendationsSection) {
    productRecommendationsSection = document.querySelector(".related-products");
  }
  if (!productRecommendationsSection) return;
  if (!productRecommendationsSection.dataset.url) return;

  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      var replacement = container.querySelector(".related-products");
      if (!replacement) return;
      productRecommendationsSection.innerHTML = replacement.innerHTML;
      initV1RelatedSwipe(productRecommendationsSection);
      requestAnimationFrame(function() {
        centerUnderfilledRelatedTrack(productRecommendationsSection);
        applyV1RelatedCardHeightScale(productRecommendationsSection);
      });
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (isThemeEditor) return;
  var target = document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products');
  if (target) {
    loadProductRecommendationsIntoSection(target);
  }
});
// Fetching the recommendations on page load
var initialRelatedProductsSection = document.querySelector(".related-products");
if (!isThemeEditor) {
  loadProductRecommendationsIntoSection(initialRelatedProductsSection);
  initV1RelatedSwipe(initialRelatedProductsSection);
  requestAnimationFrame(function() {
    centerUnderfilledRelatedTrack(initialRelatedProductsSection);
    applyV1RelatedCardHeightScale(initialRelatedProductsSection);
  });
}

window.addEventListener('resize', function() {
  centerUnderfilledRelatedTrack(document.querySelector(".related-products"));
  applyV1RelatedCardHeightScale(document.querySelector(".related-products"));
}, { passive: true });

  } catch(e) { console.error(e); }
})();
})();
